import { render, staticRenderFns } from "./IndividualExamQuestionOverviewPanel.vue?vue&type=template&id=63f6492e&scoped=true"
import script from "./IndividualExamQuestionOverviewPanel.vue?vue&type=script&lang=js"
export * from "./IndividualExamQuestionOverviewPanel.vue?vue&type=script&lang=js"
import style0 from "./IndividualExamQuestionOverviewPanel.vue?vue&type=style&index=0&id=63f6492e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f6492e",
  null
  
)

export default component.exports